module.exports = __webpack_public_path__ + "static/media/manager-r-2.d216aa90.png";